export const SET_BUSQUEDA_GLOBAL_RESULTADOS = 'SET_BUSQUEDA_GLOBAL_RESULTADOS';
